import { AloftTime, isNull, syntaxFNMA } from '@aloft/toolkit-shared';

export function getMonthFromUnix(unix: number | null): syntaxFNMA.IsoMonth | undefined {
  if (isNull(unix)) {
    return undefined;
  }
  return syntaxFNMA.aloftDateToIsoMonth(AloftTime.fromUnix(unix).toAloftDate());
}
